import { z } from "zod";

export type CustomDomainState =
  | "Initial"
  | "DomainSetupInProgress"
  | "DomainSetupFailed"
  | "DomainSetupSuccess"
  | "SSLSetupInProgress"
  | "SSLSetupFailed"
  | "SSLSetupSuccess";

export const CustomDomain = z.object({
  id: z.string(),
  designSystemId: z.string(),
  state: z.string(),

  supernovaDomain: z.string(),
  customerDomain: z.string().nullish(),

  error: z.string().nullish(),
  errorCode: z.string().nullish(),
});

export type CustomDomain = z.infer<typeof CustomDomain>;
